export const header = {
	h1: `我的邀請連結`,
	h2: `立即複製`,
	h3: `邀請地址`,
	h4: `綁定地址`,
	h5: `生態`,
	h6: `分享連結`,
	h7: `狀態`,
	h8: `未啟動`,
	h9: `已啟動`,
	h10: `首頁`,
	h11: `系統公告`,
	h12: `OIS價格`,
	h13: `分享好友`,
	h14: `佈道池`,
	h15: `挖礦算力`,
	h16: `我的社區`,
	h17: `稽核報告`,
	h18: `元宇宙`,
	h19: `遊戲`,
	h20: `已複製`,
	h21: `確認`,
	h22: `敬請期待`,
	h23: `綁定成功`,
	h24: `正在綁定關係請耐心等待（5-10）秒…`,
	h25: `礦池`,
	h26: `我的`,
	h27: `下拉即可重繪…`,
	h28: `釋放即可重繪…`,
	h29: `加載中…`,
	h30: `沒有更多了！！`,
	h31: `設定登入密碼`,
	h32: `請輸入登入密碼`,
	h33: `請確認登入密碼`,
	h34: `登入密碼`,
	h35: `重置登入密碼`,
	h36: `設定交易密碼`,
	h37: `重置交易密碼`,
	h38: `社區節點`,
	h39: `超級節點`,
	h40: `登入成功`,
	h41: `登入密碼不能為空`,
	h42: `確認密碼不能為空`,
	h43: `請設定6位字母＋數字+密碼`,
	h44: `請確認您的密碼`,
	h45: `登入密碼錯誤，請重試！！`,
	h46: `用戶不存在`,
	h47: `忘記密碼`,
	h48: `刷新成功`,
	h49: `綁定失敗，請檢查`,
	h51: `請輸入正確的綁定地址`,
	h52: `修改密碼`,
	h53: `請輸入新密碼`,
	h54: `請確認新密碼`,
	h55: `請輸入谷歌驗證碼`,
	h56: `確認`,
	h57: `谷歌驗證碼錯誤`,
	h58: `請輸入登錄密碼`,
	h59: `解綁谷歌驗證`,
	h60: `提現成功，請等待稽核`,
	h61: `交易密碼錯誤`,
	h62: `用戶不存在`,
	h63: `用戶未綁定穀歌驗證！`,
	h64: `領取成功`,
	h65: `用戶資產不存在`,
	h66: `webc資產不足`,
	h67: `USDT資產不足`,
	h68: `抽獎`,
	h69: `卡牌不存在`,
	h70: `質押成功`,
	h71: `卡片數量小於輸入數量！！`,
	h72: `交易密碼錯誤，請重試！！`,
	h73: `請輸入卡片數量 或者卡片不能小於等於0`
}
export const goodle = {
	"a0": "綁定谷歌驗證",
	"a1": "下載APP",
	"a2": "掃描二維碼",
	"a3": "備份密鑰",
	"a4": "綁定谷歌驗證",
	"a5": "成功",
	"a6": "下載並安裝身份驗證APP",
	"a7": "谷歌驗證器",
	"a8": "如何使用谷歌身份驗證器",
	"a9": "下一步",
	"a10": "用谷歌驗證APP掃描這個二維碼",
	"a11": "如果您無法掃描這個二維碼,請在APP中手動輸入這串字符。",
	"a12": "上一步",
	"a13": "將密鑰備份後保存在安全位置",
	"a14": "若您丟失手機,此密鑰可用來恢復您的身份驗證器,",
	"a15": "客服幫您重置谷歌驗證器至少需要7天。",
	"a16": "綁定谷歌驗證器前需要驗證您的賬戶",
	"a17": "請輸入谷歌驗證器的6位驗證碼",
	"a18": "安全驗證不可用?",
	"a19": "身份驗證器已綁定",
	"a20": "您已成功綁定身份驗證器來保護您的賬戶",
	"a21": "返回",
	"a22": "解綁",
	"a23": "您確定要解綁谷歌驗證器嗎?",
	"a24": "爲了保護您的資產安全，解綁驗證後該賬戶將禁用支付服務，提幣和C2C賣幣24小時，以確保您的賬戶安全。",
	"a25": "取 消",
	"a26": "確 定",
	"a27": "解綁谷歌驗證器",
	"a28": "安全驗證",
	"a29": "谷歌驗證碼",
	"a30": "穀歌驗證器APP將保護您的帳戶和提現功能。",
	"a31": "更改穀歌驗證器"
}
export const card = {
	a1: "錢包餘額",
	a2: "充值",
	a3: "提現",
	a4: "我的NFT",
	a5: "我的SNFT",
	a6: "抽獎記錄",
	a7: "抽取卡牌",
	a8: "很遺憾未中獎！",
	a9: "恭喜您中獎！",
	a10: "獲得",
	a11: "獎勵",
	a12: "暫無數據",
	a13: "請輸入金額",
	a14: "取消",
	a15: "確定",
	a16: "正在授權請耐心等待（5-10）秒...",
	a17: "輸入密碼",
	a18: "請輸入密碼",
	a19: "錢包餘額不足，購買失敗",
	a20: "恭喜您合成",
	a21: "很遺憾您未中獎",
	a22: "您已連續點擊彈窗",
	a23: "請",
	a24: "60秒",
	a25: "後再次開啟",
	a26: "您已達到當日最高抽取",
	a27: "獲得",
	a28: "盲盒數量",
	a29: "個",
	a30: "刷新成功",
	a31: "請輸入密碼",
	a32: "請輸入金額",
	a33: "授權額度查詢",
	a34: "合約錢包餘額",
	a35: "合約授權",
	a36: "合約餘額不足",
	a37: "待區塊反應",
	a38: "請先登錄",
	a39: "我的卡牌",
	a40: "SNFT合成",
	a41: "注意：每合成一張SNFT只能選擇一張UNFT",
	a42: "張",
	a43: "去合成",
	a44: "我的SNFT",
	a45: "合成記錄",
	a46: "不滿足9＋1的合成模式",
	a47: "恭喜您合成",
	a48: "合成一張",
	a49: "請勾選星球卡牌",
	a50: "共",
	a51: "恭喜獲得"
}
export const orePond = {
	a1: "礦池一",
	a2: "礦池二",
	a3: "礦池三",
	a4: "礦池四",
	a5: "天",
	a6: "收益",
	a7: "算力",
	a8: "可用額度",
	a9: "存入金額",
	a10: "LP收益",
	a11: "質押",
	a12: "贖回",
	a13: "共",
	a14: "張",
	a15: "批准",
	a16: "已批准",
	a17: "質押數量",
	a18: "贖回數量",
	a19: "請輸入數量",
	a20: "輸入密碼",
	a21: "請輸入密碼",
	a22: "錢包餘額不足，購買失敗",
	a23: "獲得",
	a24: "張",
	a25: "卡牌",
	a26: "支付",
	a27: "規則/權益",
	a28: "一星節點",
	a29: "二星節點",
	a30: "三星節點",
	a31: "請先設置密碼",
	a32: "我的UNFT",
	a33: "購買",
	a34: "我的",
	a35: "贈送記錄",
	a36: "規則/權益",
	a37: "價格",
	a38: "全網銷毀量",
	a39: "去挖礦",
	a40: "卡片挖礦",
	a41: "消費挖礦",
	a42: "暫未開放",
	a43: "購買記錄",
	a44: "限量",
	a45: "我的WEBC",
	a46: "節點",
	a47: "枚",
	a48: "每個地址限購1份，售完即止",
}
export const myself = {
	"a0": "認購",
	"a1": "我的資產",
	"a2": "我的社區",
	"a3": "邀請好友",
	"a4": "我的密碼",
	"a5": "我的交易",
	"a6": "OTC交易",
	"a7": "戰略合作夥伴",
	"a8": "邀請好友",
	"a9": "快來邀請好友一起加入吧",
	"a10": "我的推廣碼",
	"a11": "交易",
	"a12": "購買",
	"a13": "出售",
	"a14": "估價",
	"a15": "數量",
	"a16": "請輸入數量",
	"a17": "取 消",
	"a18": "確 定",
	"a19": "輸入密碼",
	"a20": "請輸入密碼",
	"a21": "錢包餘額不足，購買失敗",
	"a22": "請輸入密碼",
	"a23": "複製成功",
	"a24": "請先登錄",
	"a25": "我的資產",
	"a26": "充值",
	"a27": "提取",
	"a28": "我的NFT",
	"a29": "星系NFT",
	"a30": "我的SNFT",
	"a31": "我的UNFT",
	"a32": "我的收益",
	"a33": "收益 WEBT",
	"a34": "領取",
	"a35": "領取到餘額需扣20%的WEBC",
	"a36": "收益分類",
	"a37": "WEBT記錄",
	"a38": "挖礦收益",
	"a39": "產出WEBC：",
	"a40": "餘額",
	"a41": "我的社區",
	"a42": "社區總業績USDT",
	"a43": "我的等級：",
	"a44": "直推人數：",
	"a45": "直推清單",
	"a46": "社區成員一",
	"a47": "社區成員二",
	"a48": "社區成員三",
	"a49": "我的收益",
	"a50": "抽獎收益",
	"a51": "獲得",
	"a52": "獎勵",
	"a53": "分享收益",
	"a54": "我的密碼",
	"a55": "設置密碼",
	"a56": "重置密碼",
	"a57": "獲取簽名",
	"a58": "已獲取簽名",
	"a59": "請輸入舊密碼",
	"a60": "請設置6位字母＋數字支付密碼",
	"a61": "請確認您的支付密碼",
	"a62": "完成",
	"a63": "獲取成功",
	"a64": "請先獲取簽名",
	"a65": "兩次密碼輸入不一致",
	"a66": "設置成功",
	"a67": "OTC交易",
	"a68": "購買",
	"a69": "出售",
	"a70": "請選擇",
	"a71": "估價",
	"a72": "數量",
	"a73": "USDT餘額",
	"a74": "WEBC餘額",
	"a75": "溫馨提示：買賣費用的1％WEBC",
	"a76": "輸入密碼",
	"a77": "請輸入密碼",
	"a78": "錢包餘額不足，購買失敗",
	"a79": "請輸入數量",
	"a80": "請輸入密碼",
	"a81": "星系NFT",
	"a82": "水星",
	"a83": "共十張",
	"a84": "火星",
	"a85": "金星",
	"a86": "土星",
	"a87": "木星",
	"a88": "我的UNFT",
	"a89": "我的收益",
	"a90": "抽獎收益",
	"a91": "獲得木星獎勵",
	"a92": "分享收益",
	"a93": "USDT記錄",
	"a94": "USDT分享收益",
	"a95": "時間",
	"a96": "獎勵",
	"a97": "地址",
	"a98": "來源",
	"a99": "分享",
	"a100": "成交中,請等待！",
	"a101": "可用USDT不足！無法購買！",
	"a102": "可用webc不足！無法購買！",
	"a103": "可用Snft不足！無法出售！",
	"a104": "可用webc不足！無法出售！",
	"a105": "購買完成請耐心等待",
	"a106": "業績",
	"a107": "請確定密碼"
}
export const home = {
	h1: `OIS全網總算力`,
	h2: `OIS全網總銷毀`,
	h3: `OIS每日最高產量`,
	h4: `OIS總發行量`,
	h5: `LP池`,
	h6: `（暫未開放）`,
	h7: `質押挖礦`,
	h8: `單幣池`,
	h9: `組合池`,
	h10: `獲得OIS收益`,
	h11: `獲得USDT收益`,
	h12: `提幣`,
	h13: `合作夥伴`,
	h14: `綠洲是一個集DEFI、NET、元宇宙、鏈遊等`,
	h15: `多融性的去中心化平臺`,
	h16: `350%封頂輪回`
}
export const miningIncome = {
	m1: `佈道池挖礦收益`,
	m2: `每日產出總量（OIS）`,
	m3: `佈道池產出（OIS）`,
	m4: `個人算力`,
	m5: `挖礦收益`,
	m6: `分享收益（USDT）`,
	m7: `分享算力`,
	m8: `可提幣總數（USDT）`,
	m9: `可提幣總數（OIS）`,
	m10: `選取OIS收益`,
	m11: `選取USDT收益`,
	m12: `提示`,
	m13: `可選取數量:`,
	m14: `選取`,
	m15: `取消`,
	m16: `已提交,請等待區塊確認`
}
export const pushStraight = {
	p1: `我的直推清單`,
	p2: `地址`,
	p3: `暫無推薦地址`,
	p4: `已推薦`,
	p5: `個`,
	p6: `複製`,
	p7: `該地址直推清單`,
	p8: `確認`
}
export const vip = {
	v1: `我的等級`,
	v2: `挖礦收益`,
	v3: `VIP獲取`,
	v4: `總需`,
	v5: `購買`,
	v6: `準予`,
	v7: `說明`,
	v8: `V5封頂輪回了,V6才會點亮,V6封頂輪回了,V7才能點亮`,
	v9: `不能小於或等於當前等級`,
	v10: `已提交,請等待區塊確認`,
	v11: `授權中,請等待區塊確認`,
	v12: `確認中,請等待`,
	v13: `授權成功`,
	v14: `請勿重複購買`,
	v15: `不能購買小於當前等級的vip`,
	v16: `授權成功`,
	v17: `余额不足请充值`,
	v18: `钱包还在扣款请等待!!`,
	v19: `购买成功`,
	v20: `请耐心等待，区块链反应`,
	v21: `余额不足`,
	v22: `正在上鏈請耐心等待（10-15）秒…`
}
export const Kp = {
	a0: `轉賬`,
	a1: `閃兌`,
	a2: `轉賬記錄`,
	a3: `時間`,
	a4: `地址`,
	a5: `數量`,
	a6: `請輸入收款地址`,
	a7: `請輸入數量`,
	a8: `消耗`,
	a9: `恭喜您中獎NFT`,
	a10: `SNFT抽取算力`,
	a11: `USDT記錄`,
	a12: `收益USDT`,
	a13: `抽獎獲取SNFT算力`,
	a14: "地址不能爲空或者爲0",
	a15: "數量不能爲空或者爲0",
	a16: "接收方用戶不存在/或者接收方不是自己的下級！",
	a17: "轉賬成功",
	a18: "錢包額度不足",
	a19: "當前用戶不存在",
	a20: "交易密碼錯誤",
	a21: "轉賬金額不能小於等於0",
	a22: `用戶沒有對應的SNFT`,
	a23: `請輸入地址`,
	a24: `請輸入閃兌數量`,
	a25: `閃兌數量不能小於等於0`,
	a26: `用戶不存在`,
	a27: `閃兌成功`,
	a28: `請輸入交易密碼`,
	a29: `交易密碼錯誤`,
	a30: `用戶沒有足夠的SNFT進行閃兌`,
	a31: `類型`,
	a32: `接收方用戶不存在`,
	a33: `銀河SNFT`,
	a34: `太空SNFT`,
	a35: `宇宙SNFT`,
	a36: `可用數量`,
	a37: `張`,
	a38: `獲得`,
	a39: `確定`,
	a39: `確定`,
	a40: `歷史記錄`,
	a41: `充值`,
	a42: `提幣`,
	a43: `轉賬`,
	a44: `閃兌`,
	a45: `地址1`,
	a46: `地址2`,
	a47: `申請中`,
	a48: `審覈通過`,
	a49: `審覈拒絕`,
	a50: `幣種`,
	a51: `轉賬記錄`,
	a52: `NFT遊戲`,
	a53: `恭喜您獲得算力`,
	a54: `倍`,
	a55: `創世節點`,
	a56: `進行中`,
	a57: `已完成`,
	a58: `撤銷`,
	a59: '出售',
	a60: `購買`,
	a61: `買賣清單`,
	a62: `操作`,
	a63: `方向`,
	a64: `金額`,
	a65: `等待成交`,
	a66: `部分成交`,
	a67: `全部成交`,
	a68: `取消`,
	a69: `是否取消訂單？`,
	a70: `Otc訂單不存在`,
	a71: `Otc訂單已經全部成交，或成交數量已經爲0`,
	a72: `取消otc訂單成功`,
	a73: "礦池1",
	a74: "礦池2",
	a75: "礦池3",
	a76: "礦池4",
	a77: "銷燬",
	a78: "此操作將去首頁抽取SNFT盲盒是否確定？",
	a79: "礦池二全網算力",
	a80: "礦池二全網產出",
	a81: "礦池二個人算力",
	a82: "礦池二個人產出",
	a83: "提取",
	a84: "提取數量",
	a85: "請輸入數量",
	a86: "請勿重複質押",
	a87: "正在質押請耐心等待（5-10）秒...",
	a88: "授權失敗",
	a89: "質押成功",
	a90: "質押失敗，請檢查",
	a91: "鏈上質押失敗",
	a92: "質押數量不能爲小於0或者爲空",
	a93: "質押數量必須小於等於可用餘額",
	a94: "時間未到，禁止贖回",
	a95: "沒有可贖回的，請先質押",
	a96: "贖回數量不能爲空或者爲0",
	a97: "贖回數量必須小於等於存入金額額",
	a98: "禁止點擊，只允許贖回最大",
	a99: "贖回成功",
	a100: "贖回失敗，請檢查",
	a101: "鏈上贖回失敗",
	a102: "正在贖回請耐心等待（5-10）秒...",
	a103: "購買成功",
	a104: "記錄",
	a105: "USDT購買UNFT",
	a106: "UNFT向下轉賬-接收方",
	a107: "UNFT向下轉賬-發送方",
	a108: "請先陞級為V1或以上等級",
	a109: "礦池一全網算力",
	a110: "礦池一全網產出",
	a111: "礦池一個人算力",
	a112: "礦池一個人產出",
	a113: "SNFT銷燬抽取算力",
	a114: "選擇銷燬類型",
	a115: "選擇盲盒類型",
	a116: "全網算力",
	a117: "全網產出",
	a118: "個人算力",
	a119: "個人產出",
	a120: "僅支持質押與贖回最大",
	a121: "僅支持最大提取",
	a122: "WEBC記錄",
	a123: "購買UNFT沒有開放",
	a124:"凍結餘額",
	a125:"可用餘額",
	a126:"凍結收益",
	a127:"算力餘額",
	a128:"分類"
}
export const flowType = {
	"a0": "節點認購",
	"a1": "鏈上充值",
	"a2": "後臺充值",
	"a3": "抽取卡牌-中獎",
	"a4": "抽取卡牌-消費",
	"a5": "抽獎返還-(沒有中獎)",
	"a6": "抽獎收益-(沒有中獎)",
	"a7": "推廣獎勵-管理級差獎",
	"a8": "推廣獎勵-直推獎",
	"a9": "卡牌合成-消費",
	"a10": "卡牌合成-成功",
	"a11": "節點認購-分紅獎勵",
	"a12": "otc購買下單-扣除可用Usdt",
	"a13": "otc購買下單-增加凍結Usdt",
	"a14": "otc購買下單-扣除手續費",
	"a15": "otc成交",
	"a16": "otc出售下單-扣除可用SNTF",
	"a17": "otc出售下單-扣除手續費",
	"a18": "領取我的收益",
	"a19": "用戶申請提現",
	"a20": "礦池2號-挖礦收益",
	"a21": "銷燬卡片獲得算力",
	"a22": "提現-通過",
	"a23": "提現-拒絕",
	"a24": "礦池1號-挖礦收益",
	"a25": "UNFT向下轉賬-接收方",
	"a26": "UNFT向下轉賬-發送方",
	"a27": "用戶兌換-WEBT兌換成USDT",
	"a28": "閃兌snft爲WEBT",
	"a29": "提現USDT-扣除WEBC手續費",
	"a30": "提現WEBC-扣除WEBC手續費",
	"a31": "卡牌合成-手續費",
	"a32": "USDT向下轉賬-接收方",
	"a33": "USDT向下轉賬-發送方",
	"a34": "WEBC向下轉賬-接收方",
	"a35": "WEBC向下轉賬-發送方",
	"a36": "用戶兌換-USDT兌換成WEBT",
	"a37": "結算收益減少算力",
	"a38": "WEBT向下轉賬-接收方",
	"a39": "WEBT向下轉賬-發送方",
	"a40": "otc取消訂單",
	"a41": "otc取消出售訂單-歸還手續費",
	"a42": "otc取消出售訂單-歸還SNFT",
	"a43": "領取我的礦池一收益-增加資產",
	"a44": "領取我的礦池二收益-增加資產",
	"a45": "使用USDT購買UNFT",
	"a46": "銷燬卡片",
	"a47": "質押LP",
	"a48": "質押LP獲得算力",
	"a49": "領取我的礦池一收益-減少產出",
	"a50": "領取我的礦池二收益-減少產出"
}